import '../css/EditVideo.css';
import toast from 'react-hot-toast';
import { useUser } from '../hooks/useUser';
import { Video } from '../interfaces/userInterfaces';
import { editUserVideo } from '../services/fetch-utils';
import { Dispatch, SetStateAction, useState } from 'react';

interface EditVideoProps {
  video: Video;
  setShowEditForm: Dispatch<SetStateAction<boolean>>;
}

export const EditVideo: React.FC<EditVideoProps> = ({ video, setShowEditForm }) => {
  const { user, isUserProfile, updateUserVideoListAfterAction } = useUser();

  const [title, setTitle] = useState<string>(video.title);
  const [description, setDescription] = useState<string>(video.description);

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDescription(e.target.value);
  };

  const resetInputs = () => {
    setTitle('');
    setDescription('');
  };

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (user && isUserProfile(user)) {
      const edit = editUserVideo(video.video_id, title, description)
        .catch((error) => error.message)
        .then(() => updateUserVideoListAfterAction(user.user_id))
        .then(() => resetInputs())
        .then(() => setShowEditForm(false));

      toast.promise(edit, {
        loading: 'Just a moment while we edit your Video',
        success: 'Video successfully edited',
        error: 'Oops! Something went wrong. Please try again',
      });
    }
  };

  return (
    <form id="edit-video-form" onSubmit={handleSubmit}>
      Edit Video
      <label className="video-edit-inputs title">
        New Title : <input type="text" value={title} onChange={handleTitleChange}></input>
      </label>
      <label className="video-edit-inputs description">
        New Description :{' '}
        <input type="text" value={description} onChange={handleDescriptionChange}></input>
      </label>
      <span id="edit-form-cancel-submit-buttons">
        <button onClick={() => setShowEditForm(false)}>Cancel Edit</button>
      </span>
      <button>Submit</button>
    </form>
  );
};
